import { getUrlVars, getCurrentLanguage, updateQueryString } from "/Assets/js/utilities.js";
import * as tomSelect from "/Assets/libs/TomSelect/tom-select.complete.js";

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector("[data-cascading-form-container-block]")) {
        const cascadingFormContainerBlock = new CascadingFormContainerBlock();
        cascadingFormContainerBlock.init();
    }
});

class CascadingFormContainerBlock {
    constructor() {
        this.qs = getUrlVars();
    }

    init() {
        const self = this;
        const formName = this.getFormNameFromUrl();

        document.querySelectorAll("[data-cascading-form-block-button]").forEach(el => {
            const select = el.querySelector("select");
            const control = new tomSelect(select, {
                onChange: function (value) {
                    self.onSelectListItemClicked(value);
                }
            });

            if (typeof formName !== "undefined") {
                control.setValue(formName);
            }
        });
    }

    onSelectListItemClicked(value) {
        if (value === "where-to-buy") {
            const lang = getCurrentLanguage() === "en" ? "" : `/${getCurrentLanguage()}`;
            window.location.href = `${lang}/where-to-buy/where-to-buy-contact-information/`;
        } else {
            this.resetForm(value);
            this.loadForm(value);
            this.updateFormNameInUrl(value);
        }
    }

    loadForm(formName) {
        if (!formName) {
            return;
        }

        const containers = document.querySelectorAll("[data-form-container]");
        containers.forEach(container => container.classList.add("hidden"));

        const targetContainer = Array.from(containers).find(item => item.dataset.formContainer === formName);
        targetContainer.classList.remove("hidden");
    }

    resetForm(formName) {
        if (!formName) {
            return;
        }

        const containers = document.querySelectorAll("[data-form-container]");
        const targetContainer = Array.from(containers).find(item => item.dataset.formContainer === formName);
        const targetForm = targetContainer.querySelector("form");

        targetForm.reset();
        //TODO fix this after replacing selects with tom-select
        //targetForm.querySelectorAll("div.combobox input[type=hidden]").forEach(input => input.value = "");
        document.querySelectorAll(".Form__Element__ValidationError").forEach(el => el.textContent = "");
        targetForm.querySelectorAll(".ValidationFail").forEach(el => el.classList.remove("ValidationFail"));
        targetForm.querySelectorAll(".ValidationSuccess").forEach(el => el.classList.remove("ValidationSuccess"));
    }

    updateFormNameInUrl(formName) {
        if (!window.history.replaceState) {
            return;
        }
        const curUrl = window.location.href.split("#")[0];
        const newUrl = updateQueryString("form", formName, curUrl);
        window.history.replaceState({}, "Page:" + formName, newUrl);
    }

    getFormNameFromUrl() {
        const qsForm = this.qs["form"] ? this.qs["form"] : this.qs["Form"];
        const lochash = location.hash.substr(1);
        const formHash = lochash.substr(lochash.indexOf("form=")).split("&")[0].split("=")[1];
        return qsForm != null ? qsForm : formHash;
    }
}
